<template>
    <div>
        <v-form ref="form">
            <v-row class="mobile-scroll">
                <v-col cols="12" sm="6" lg="4">
                    <v-card class="soli-round">
                        <v-container>
                            <v-card-title
                                class="justify-space-between soli-grey"
                            >
                                Login Details
                            </v-card-title>
                            <v-container>
                                <v-row>
                                    <v-col class="flex justify-center">
                                        <v-avatar
                                            class="shadow-blue"
                                            :size="
                                                user.profile_photo_path
                                                    ? 200
                                                    : 125
                                            "
                                        >
                                            <v-img
                                                :src="
                                                    hasPhoto
                                                        ? `/api/image-service/200x200/${user.profile_photo_path}`
                                                        : user.profile_photo_url
                                                "
                                            ></v-img>
                                        </v-avatar>

                                        <!-- Profile Photo File Input -->
                                        <input
                                            type="file"
                                            class="hidden"
                                            ref="photo"
                                            @input="convertPhoto($event)"
                                        />
                                    </v-col>
                                    <v-row
                                        v-if="errors.photo"
                                        class="justify-center w-full my-1"
                                        ><small class="red--text">{{
                                            errors.photo
                                        }}</small></v-row
                                    >
                                    <v-row
                                        v-if="
                                            relationshipsAndMe ||
                                            can('Edit profile photos')
                                        "
                                        :class="['my-3 justify-center w-full']"
                                    >
                                        <v-btn
                                            text
                                            small
                                            plain
                                            color="dark"
                                            :class="[
                                                'soli-round',
                                                hasPhoto ? 'ml-3.5' : null,
                                            ]"
                                            type="button"
                                            @click.native.prevent="
                                                selectNewPhoto
                                            "
                                            >{{
                                                hasPhoto
                                                    ? "Edit Photo"
                                                    : "Add Photo"
                                            }}
                                        </v-btn>
                                        <div
                                            v-show="hasPhoto"
                                            class="soli-grey-text"
                                        >
                                            |
                                        </div>
                                        <v-btn
                                            small
                                            plain
                                            text
                                            color="dark"
                                            class="soli-round"
                                            @click.native.prevent="deletePhoto"
                                            v-if="hasPhoto"
                                            >Delete Photo
                                        </v-btn>
                                    </v-row>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <SoliText
                                            v-model="form.email"
                                            :errors="errors.email"
                                            :rules="
                                                !user.loginable
                                                    ? []
                                                    : rules.email
                                            "
                                            icon="alternate_email"
                                            label="Email"
                                        ></SoliText>
                                        <SoliUserLocation
                                            v-if="
                                                $page.props.staffView &&
                                                can('Manage user locations')
                                            "
                                            v-model="form.locations"
                                            :locations="
                                                $page.props.auth.user.locations
                                            "
                                            :rules="rules.input"
                                            multiple
                                            idOnly
                                        />
                                        <!--<v-select
                      :items="timezones"
                      v-model="form.timezone"
                      label="Timezone"
                      prepend-inner-icon="watch"
                      outlined
                      :rules="rules.select"
                      dense
                    >
                    </v-select>-->
                                        <v-text-field
                                            v-if="
                                                user.hasRoles.includes(
                                                    'Teacher'
                                                )
                                            "
                                            :rules="validUrl"
                                            v-model="form.zoom_url"
                                            dense
                                            validate-on-blur
                                            outlined
                                            class="soli-round"
                                            prepend-inner-icon="videocam"
                                            label="Online Meeting Link"
                                            placeholder="https://"
                                        ></v-text-field>
                                        <v-switch
                                            v-if="
                                                user.email &&
                                                $page.props.staffView &&
                                                can('Manage logins')
                                            "
                                            class="mt-0 mx-1"
                                            dense
                                            label="Active Login"
                                            v-model="form.loginable"
                                            @change="
                                                !$event && user.loginable
                                                    ? (confirmActiveUser = true)
                                                    : null
                                            "
                                        ></v-switch>
                                        <SoliForm
                                            v-if="
                                                choicePassword &&
                                                $page.props.auth.user.email ==
                                                    user.email
                                            "
                                            @reset="[(choicePassword = false)]"
                                            ref="soliForm"
                                            text="Save"
                                            icon="save"
                                            @submit="updatePassword"
                                            title="Update Password"
                                            textSubtitle="Ensure your account is using a long, random password to stay secure."
                                        >
                                            <template #body>
                                                <SoliText
                                                    name="current-password"
                                                    v-model="
                                                        passwordForm.current_password
                                                    "
                                                    :errors="
                                                        passwordForm.errors
                                                            .current_password
                                                    "
                                                    :rules="rules.input"
                                                    label="Current Password"
                                                    required
                                                    :password="true"
                                                    :show="show"
                                                    @append="show = !show"
                                                ></SoliText>
                                                <SoliText
                                                    name="password"
                                                    v-model="
                                                        passwordForm.password
                                                    "
                                                    :errors="
                                                        passwordForm.errors
                                                            .password
                                                    "
                                                    :rules="rules.input"
                                                    label="New Password"
                                                    required
                                                    :password="true"
                                                    :show="show"
                                                    @append="show = !show"
                                                ></SoliText>
                                                <SoliText
                                                    name="password_confirmation"
                                                    v-model="
                                                        passwordForm.password_confirmation
                                                    "
                                                    :errors="
                                                        passwordForm.errors
                                                            .password_confirmation
                                                    "
                                                    :rules="rules.input"
                                                    label="Confirm Password"
                                                    required
                                                    :password="true"
                                                    :show="show"
                                                    @append="show = !show"
                                                ></SoliText>
                                            </template>
                                        </SoliForm>
                                        <div class="flex justify-end">
                                            <v-btn
                                                v-if="can('Delete users')"
                                                plain
                                                small
                                                rounded
                                                color="error"
                                                @click="confirmDelete = true"
                                                >Remove</v-btn
                                            >
                                            <v-btn
                                                color="accent"
                                                plain
                                                small
                                                rounded
                                                v-if="
                                                    $page.props.auth.user.id ==
                                                        user.id ||
                                                    can('Reset passwords')
                                                "
                                                @click="choicePassword = true"
                                                :disabled="
                                                    editing ||
                                                    !user.email ||
                                                    !user.loginable
                                                "
                                            >
                                                Reset Password
                                            </v-btn>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-container></v-card
                    >
                </v-col>

                <v-col cols="12" sm="6" lg="4">
                    <v-card class="soli-round">
                        <v-container>
                            <v-card-title class="soli-grey">
                                User Info
                            </v-card-title>
                            <v-container>
                                <v-row>
                                    <v-col class="pb-0">
                                        <SoliText
                                            v-model="form.first_name"
                                            :errors="errors.first_name"
                                            :rules="rules.input"
                                            icon="person"
                                            label="First Name"
                                        ></SoliText>
                                    </v-col>
                                    <v-col class="pb-0">
                                        <SoliText
                                            v-model="form.last_name"
                                            :errors="errors.last_name"
                                            :rules="rules.input"
                                            label="Last Name"
                                        ></SoliText>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="py-0">
                                        <v-select
                                            :items="[
                                                'She/her',
                                                'He/his',
                                                'She/they',
                                                'He/they',
                                                'They/their',
                                                'Other',
                                            ]"
                                            label="Pronouns"
                                            v-model="form.pronouns"
                                            prepend-inner-icon="all_inclusive"
                                            outlined
                                            dense
                                        ></v-select>
                                        <SoliText
                                            v-model="form.phone"
                                            @input="maskPhone"
                                            icon="phone"
                                            label="Phone"
                                            ref="phone"
                                            placeholder="10-digits"
                                            :errors="errors.phone"
                                            :rules="rules.phoneNotRequired"
                                            phone
                                        ></SoliText>
                                        <SoliDate
                                            v-if="viewSensitiveData"
                                            v-model="form.birthday"
                                            clearable
                                            label="Birthday"
                                            :errors="errors.input"
                                            :rules="[]"
                                            icon="cake"
                                            birthday
                                            @clear="form.birthday = null"
                                        ></SoliDate>
                                        <SoliAddress
                                            v-if="viewSensitiveData"
                                            v-model="form.address"
                                            :errors="errors.address"
                                            :rules="
                                                $page.props.staffView ||
                                                !user.email
                                                    ? []
                                                    : rules.input
                                            "
                                            :address="user.address"
                                            :city="user.city"
                                            @setAddress="
                                                [
                                                    (form.address =
                                                        $event.address),
                                                    (form.city = $event.city),
                                                ]
                                            "
                                        ></SoliAddress>

                                        <SoliText
                                            v-if="viewSensitiveData"
                                            v-model="form.zip_code"
                                            icon="location_city"
                                            label="Zip Code"
                                            ref="zip"
                                            :errors="errors.zip_code"
                                            :rules="
                                                can('Manage user locations') &&
                                                $page.props.staffView
                                                    ? rules.zipCodeNotRequired
                                                    : rules.zipCode
                                            "
                                            zipCode
                                        ></SoliText>

                                        <SoliText
                                            v-if="viewSensitiveData"
                                            v-model="form.apartment"
                                            icon="apartment"
                                            label="Apartment"
                                            ref="apartment"
                                            :errors="errors.apartment"
                                        ></SoliText>
                                    </v-col>
                                </v-row>
                            </v-container> </v-container
                    ></v-card>
                </v-col>
                <v-col cols="12" lg="4" v-if="isTeacher">
                    <v-card class="soli-round">
                        <v-container>
                            <v-card-title
                                >Teacher Biography<v-icon
                                    v-if="!user.bio?.content?.length"
                                    right
                                    color="error"
                                    >error_outline</v-icon
                                ></v-card-title
                            >
                            <v-card-subtitle
                                v-if="form.bio?.length"
                                class="pb-1"
                                >{{
                                    `Last Updated ${globalMomentFullDateAtTime(
                                        user.bio?.updated_at
                                    )}`
                                }}</v-card-subtitle
                            >
                            <v-card-subtitle class="pt-0 px-3">
                                <v-btn
                                    @click="showBioHelpForm = true"
                                    x-small
                                    outlined
                                    :disabled="
                                        summarizeLoading ||
                                        !!user.bio?.content?.length
                                    "
                                    class="soli-round soli-blue-text"
                                    >Help Getting Started</v-btn
                                >
                                <v-btn
                                    @click="helpSummarize()"
                                    :disabled="
                                        !form.bio?.length ||
                                        form.bio?.length <= 750
                                    "
                                    x-small
                                    outlined
                                    class="soli-round soli-blue-text"
                                    :loading="summarizeLoading"
                                    >Help Summarizing</v-btn
                                ></v-card-subtitle
                            >
                            <v-textarea
                                :placeholder="`Brief description of ${user.first_name}'s experience as a musician and educator.`"
                                outlined
                                dense
                                autoGrow
                                class="soli-round px-3"
                                v-model="form.bio"
                                :rules="[
                                    (v) =>
                                        (v || '').length <= 750 ||
                                        `Character limit reached`,
                                ]"
                            ></v-textarea>
                        </v-container>
                    </v-card>
                </v-col>
            </v-row>
        </v-form>
        <SoliChoice
            title="Update Password"
            :subtitle="`Send password reset link to ${user.email}?`"
            @option1="requestPassword"
            button1="Send Link!"
            button2="Nevermind"
            @reset="choicePassword = false"
            v-if="
                choicePassword &&
                can('Reset passwords') &&
                $page.props.auth.user.id !== user.id
            "
        ></SoliChoice>
        <SoliChoice
            title="Are you sure?"
            :subtitle="`${user.first_name}'s login will be deactivated, removing access to our software. This will not delete the account.`"
            button1="Continue"
            button2="Nevermind"
            @option2="form.loginable = user.loginable"
            @reset="confirmActiveUser = null"
            v-if="confirmActiveUser"
            permanent
        ></SoliChoice>
        <SoliResponsiveDialog
            v-if="confirmDelete"
            ref="deleteForm"
            title="Delete User"
            :subtitle="
                deleteForm.option?.warning ?? 'How would you like to proceed?'
            "
            warning
            button1="Confirm"
            button2="Nevermind"
            @reset="confirmDelete = false"
        >
            <template #body>
                <v-form @submit.prevent="deleteForm.option">
                    <div class="flex flex-col gap-4 pa-2">
                        <v-select
                            v-model="deleteForm.option"
                            :items="deleteOptions"
                            outlined
                            dense
                            return-object
                            hide-details="auto"
                            prepend-inner-icon="delete"
                            label="Select Method"
                            :rules="rules.select"
                        />
                        <SoliStudents
                            v-if="deleteForm.option?.clientSelect"
                            v-model="deleteForm.user"
                            :rules="
                                deleteForm.option?.clientSelect
                                    ? rules.select
                                    : []
                            "
                        />
                        <v-divider />
                    </div>
                </v-form>
                <v-card-actions class="pb-0">
                    <v-spacer />
                    <v-btn
                        text
                        rounded
                        class="soli-grey"
                        @click="$refs.deleteForm.show = false"
                        >Nevermind</v-btn
                    >
                    <v-btn
                        color="error"
                        text
                        rounded
                        :loading="deleteForm.loading"
                        :disabled="!deleteForm.option"
                        @click="deleteForm.option.method()"
                        >Confirm</v-btn
                    >
                </v-card-actions>
            </template>
        </SoliResponsiveDialog>
        <v-dialog v-model="showImageEditor" max-width="425" class="soli-round">
            <v-card class="soli-round" style="overflow: hidden">
                <v-container v-if="cropperLoading">
                    <v-skeleton-loader class="soli-round" type="image" />
                </v-container>
                <VueCropper
                    v-show="!cropperLoading"
                    ref="cropper"
                    :src="null"
                    :aspectRatio="1"
                    alt="Loading"
                />
                <v-card-actions class="justify-end">
                    <v-btn
                        plain
                        color="soli-grey soli-round"
                        text
                        @click="closeModal(() => (showImageEditor = false))"
                        >Cancel</v-btn
                    >
                    <v-btn
                        class="soli-blue white--text soli-round"
                        :loading="imageLoading"
                        @click="
                            updatePhoto(),
                                closeModal(() => (showImageEditor = false))
                        "
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
        <SoliForm
            v-if="showBioHelpForm"
            ref="bioHelpForm"
            title="Help Me Write A Biography"
            textSubtitle="I'm not a perfect robot, but I can get you started."
            persistent
            @submit="helpCompose()"
            @reset="closeModal(() => (showBioHelpForm = false))"
        >
            <template #body>
                <SoliText
                    label="List any degrees and where they're from"
                    v-model="bioHelpForm.degrees"
                />
                <SoliText
                    label="How long have you been teaching music?"
                    v-model="bioHelpForm.experience"
                />
                <SoliText
                    label="Where do you perform and with who? Highlights only!"
                    v-model="bioHelpForm.perform"
                />
                <v-textarea
                    class="soli-round"
                    hide-details
                    outlined
                    auto-grow
                    flat
                    label="What is unique about your experience or teaching?"
                    v-model="bioHelpForm.about"
                />
            </template>
        </SoliForm>
    </div>
</template>

<script>
import SoliForm from "./../Base/SoliForm";
import { path } from "ramda";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import globalMoment from "../../Mixins/GlobalMoment.js";
import SoliResponsiveDialog from "../Base/SoliResponsiveDialog.vue";

export default {
    name: "UserProfile",
    mixins: [globalMoment],
    props: {
        user: {},
        errors: {},
        relationships: {
            type: Array,
            default: () => [],
        },
    },
    components: { VueCropper },
    data: function () {
        return {
            form: {
                first_name: this.user.first_name,
                last_name: this.user.last_name,
                email: this.user.email,
                locations: this.user.locations.map((e) => e.id),
                pronouns: this.user.pronouns,
                phone: this.user.phone,
                address: this.user.address,
                city: this.user.city,
                loginable: this.user.loginable,
                birthday: this.user.birthday
                    ? this.globalMomentDate(this.user.birthday)
                    : null,
                zoom_url: this.user.zoom_url,
                zip_code: this.user.zip_code,
                apartment: this.user.apartment,
                bio: this.user.bio?.content ?? null,
                //timezone: this.user.timezone,
            },
            bioHelpForm: {
                experience: null,
                degrees: null,
                about: null,
                perform: null,
            },
            passwordForm: this.$inertia.form({
                current_password: null,
                password: null,
                password_confirmation: null,
            }),
            photoForm: this.$inertia.form(
                {
                    _method: "PUT",
                    email: this.user.email,
                    photo: null,
                },
                {
                    bag: "updateProfileInformation",
                    resetOnSuccess: false,
                }
            ),
            deleteForm: this.$inertia.form({
                option: null,
                user: null,
                loading: false,
            }),
            //timezones: moment.tz.zonesForCountry('US'),
            showBioHelpForm: false,
            cropperLoading: false,
            imageLoading: false,
            photoFile: null,
            selectedPhoto: null,
            showImageEditor: false,
            activeUser: true,
            confirmActiveUser: null,
            formCopy: null,
            show: false,
            choicePassword: false,
            editing: false,
            bdayMenu: false,
            rules: SoliForm.formRules,
            summarizeLoading: false,
            confirmDelete: false,
            validUrl: [
                (v) => {
                    if (!v) return true;
                    try {
                        return new URL(v) &&
                            (v.includes("zoom.us") ||
                                v.includes("meet.google.com"))
                            ? true
                            : false;
                    } catch (_) {
                        return "Must be a valid Zoom or Google Meet link.";
                    }
                },
            ],
            deleteOptions: [
                {
                    text: "Delete",
                    value: "delete",
                    warning: `Are you sure you want to delete ${this.user.first_name}'s account?`,
                    clientSelect: false,
                    method: () => this.deleteUser(),
                },
                /*{
                    text: "Merge",
                    value: "merge",
                    warning: `This will merge ${this.user.first_name}'s account into the selected user. This cannot be undone.`,
                    clientSelect: true,
                    method: () => this.mergeUser(),
                },*/
                {
                    text: "Anonymize",
                    value: "anonymize",
                    warning: `This will make ${this.user.first_name}'s data anonymous and archive their account. This should only be done at the client's request for data removal. This cannot be undone.`,
                    clientSelect: false,
                    method: () => this.anonymizeUser(),
                },
            ],
        };
    },
    methods: {
        deleteUser() {
            this.deleteForm.loading = true;
            this.$inertia.delete(`/users/${this.user.id}`, {
                preserveState: true,
                preserveScroll: true,
                onSuccess: () => {
                    this.$emit("success");
                    this.formCopy = JSON.stringify(this.form);
                    this.editing = false;
                    this.confirmDelete = false;
                    this.deleteForm.reset();
                    this.$emit("reset");
                },
                onError: (error) => {
                    this.deleteForm.loading = false;
                },
            });
        },
        mergeUser() {
            this.deleteForm.loading = true;
            this.deleteForm.post(`/users/${this.user.id}/merge`, {
                preserveState: true,
                preserveScroll: true,
                onError: (error) => {
                    this.deleteForm.loading = false;
                },
            });
        },
        anonymizeUser() {
            this.deleteForm.loading = true;
            this.deleteForm.post(`/users/${this.user.id}/anonymize`, {
                preserveState: true,
                preserveScroll: true,
                onError: (error) => {
                    this.deleteForm.loading = false;
                },
            });
        },
        maskPhone(value) {
            if (!value) return;
            let x = value
                .replace(/\D/g, "")
                .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);

            this.form.phone = !x[2]
                ? x[1]
                : x[1] + "-" + x[2] + (x[3] ? "-" + x[3] : "");
        },
        selectNewPhoto(e) {
            this.$refs.photo.click();
            this.cropperLoading = true;
        },
        convertPhoto(e) {
            this.photoFile = e.target.files[0];
            this.showImageEditor = true;
            let reader = new FileReader();
            reader.onload = (e) => {
                let img = new Image();
                img.src = e.target.result;
                img.onload = () => {
                    this.resizeImage(this.photoFile, img);
                };
            };

            reader.readAsDataURL(this.photoFile);
        },
        resizeImage(file, img) {
            let canvas = document.createElement("canvas");
            let ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);

            let maxWidth = 1000;
            let maxHeight = 1000;
            let width = img.width;
            let height = img.height;
            let aspectRatio = Math.min(maxWidth / width, maxHeight / height);

            let adjustedWidth = width * aspectRatio;
            let adjustedHeight = height * aspectRatio;

            canvas.width = adjustedWidth;
            canvas.height = adjustedHeight;
            ctx.drawImage(img, 0, 0, adjustedWidth, adjustedHeight);
            let dataUrl = canvas.toDataURL(file.type);
            this.$refs.cropper.replace(dataUrl);
            this.cropperLoading = false;
        },
        updatePhoto() {
            this.imageLoading = true;
            this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
                this.photoForm.photo = blob;
                this.photoForm.post(`/users/${this.user.id}/profile-photo`, {
                    preserveScroll: true,
                    onSuccess: () => {
                        this.photoForm.reset();
                        this.$refs.photo.value = null;
                        this.imageLoading = false;
                    },
                    onError: (error) => {
                        console.log(error.photo);
                        this.imageLoading = false;
                    },
                });
            });
            //this.photoForm.post("/user/profile-information", {
        },
        deletePhoto() {
            this.$inertia.delete(
                `/users/${this.user.id}/remove-profile-photo`,
                {
                    preserveScroll: true,
                    onSuccess: () => {
                        this.photoForm.reset();
                        this.$refs.photo.value = null;
                    },
                }
            );
        },
        cancel() {
            this.$inertia.visit(this.$page.url);
        },
        save() {
            if (this.$refs.form.validate()) {
                this.$emit("submit");
                this.$inertia.put(`/users/${this.user.id}`, this.form, {
                    preserveState: true,
                    preserveScroll: true,
                    onSuccess: () => {
                        this.$emit("success");
                        this.editing = false;
                        this.formCopy = JSON.stringify(this.form);
                        this.$emit("reset");
                    },
                    onError: (errors) => {
                        console.log(
                            "Form returned errors: " + JSON.stringify(errors)
                        );
                        this.$emit("reset");
                    },
                });
            } else {
                this.$nextTick(() => {
                    let scrollToError =
                        this.$el.querySelector(".error--text").offsetTop;
                    window.scrollTo(0, scrollToError);
                });
            }
        },
        requestPassword() {
            this.$inertia.post(
                this.route("password.email"),
                { email: this.user.email },
                {
                    preserveState: (page) =>
                        Object.keys(page.props.errors).length,
                    preserveScroll: true,
                    onSuccess: () => {
                        this.choicePassword = false;
                    },
                }
            );
        },
        updatePassword() {
            //TODO this should end other user sessions
            this.passwordForm.put(route("user-password.update"), {
                preserveState: (page) => Object.keys(page.props.errors).length,
                preserveScroll: true,
                errorBag: "updatePassword",
                onSuccess: () => {},
                onError: () => (this.$refs.soliForm.loading = false),
            });
        },
        helpCompose() {
            axios
                .get("/api/openai/compose", {
                    params: {
                        name: this.user.name,
                        locations: this.user.locations.map((e) => e.name),
                        instruments: this.user.instruments?.map((e) => e.name),
                        ageRanges: this.user.instruments
                            .map((e) => e.pivot)
                            .map((e) => e.age_ranges)
                            .flat()
                            .map((e) => e.name.split(" (")[0]),
                        degrees: this.bioHelpForm.degrees,
                        experience: this.bioHelpForm.experience,
                        perform: this.bioHelpForm.perform,
                        about: this.bioHelpForm.about,
                    },
                })
                .then((resp) => {
                    this.form.bio = resp.data.choices[0].message.content.trim();
                    this.closeModal(() => (this.showBioHelpForm = false));
                })
                .catch((error) => {
                    console.log(error);
                    this.$page.props.errors = {
                        soliError:
                            "Sorry, I'm not a perfect robot. Please try again.",
                    };
                    this.$refs.bioHelpForm.loading = false;
                });
        },
        helpSummarize() {
            this.summarizeLoading = true;
            axios
                .get("/api/openai/summarize", {
                    params: {
                        biography: this.form.bio,
                    },
                })
                .then((resp) => {
                    console.log(resp.data.choices[0]);
                    this.form.bio = resp.data.choices[0].message.content.trim();
                    this.summarizeLoading = false;
                })
                .catch((error) => {
                    this.$page.props.errors = {
                        soliError:
                            "Sorry, I'm not a perfect robot. Please try again.",
                    };
                    this.summarizeLoading = false;
                });
        },
    },
    computed: {
        isTeacher() {
            return (
                this.user.hasRoles.includes("Teacher") &&
                this.$page.props.staffView
            );
        },
        isArchivedTeacher() {
            return this.user.hasRoles.includes("Archived Teacher");
        },
        hasPhoto() {
            return this.user.profile_photo_path ? true : false;
        },
        relationshipsAndMe() {
            let relationships = this.relationships || [];
            let arr = [...relationships].map((e) => e.id);
            arr.push(this.user.id);
            return arr.includes(this.$page.props.auth.user.id);
        },
        viewSensitiveData() {
            return (
                this.relationshipsAndMe ||
                this.can("View sensitive profile data")
            );
        },
    },
    mounted() {
        this.maskPhone(this.form.phone);
        this.formCopy = JSON.stringify(this.form);
    },
    beforeDestroy() {
        this.$emit("editing", false);
    },
    watch: {
        form: {
            handler: function (val) {
                if (JSON.stringify(val) == this.formCopy) {
                    this.editing = false;
                } else {
                    this.editing = true;
                }
            },
            deep: true,
        },
        editing(editing) {
            this.$emit("editing", editing);
        },
    },
};
</script>
